import { useState, useEffect } from 'react'
import { Table, Tag } from 'mk-pc'
import { CommonStatus } from '@mkmp/core'
import { queryAppList } from '../service'
import '../styles/application.scss'

/**
 * 应用管理
 */
export const Application = () => {
  const [apps, setApps] = useState([] as any)

  useEffect(() => {
    fetchData()
  }, [])

  /**
   * 获取应用列表
   */
  const fetchData = async () => {
    const list = await queryAppList({})
    setApps(list)
  }

  return (
    <section className="os-application">
      <div className="os-application__list">
        <Table dataSource={apps} scroll={{ x: 'max-content' }} pagination={false}>
          <Table.Column title="应用编码" dataIndex="code" key="code" width={140} />
          <Table.Column title="应用名称" dataIndex="name" key="name" width={140} />
          <Table.Column title="应用路径" dataIndex="url" key="url" width={300} />
          <Table.Column title="基础路由" dataIndex="baseRoute" key="baseRoute" width={150} />
          <Table.Column
            title="类型"
            dataIndex="mainApp"
            key="mainApp"
            width={120}
            render={(_: any, record: any) => {
              return record.mainApp ? <Tag color="#A51F24">主应用</Tag> : <Tag>子应用</Tag>
            }}
          />
          <Table.Column title="排序" dataIndex="order" key="order" width={100} />
          <Table.Column
            title="状态"
            dataIndex="status"
            key="status"
            width={100}
            render={(_: any, record: any) => <CommonStatus status={record.status} />}
          />
        </Table>
      </div>
    </section>
  )
}
